export class SocketLiveData {
  data_of: LiveChannelDataType;
  data: any;
}

export class EvictionPrintAlert {
  case_id: string;
  url: string;
}

export enum LiveChannelDataType {
  PRINT = 'PRINT',
  NOTIFICATION = 'NOTIFICATION',
  GENERATE_FORM = 'GENERATE_FORM'
}
